import React, {useRef} from 'react'
import {useFormikContext} from 'formik'
import {FieldInput} from '../field-input'
import {Grid, VStack} from '@chakra-ui/react'

interface AddressInputFieldsProps {
  name: string
  handleBlur?: (e?: any) => void
  disabled?: boolean
  handleChange?: (e: any) => void
}

export const AddressInputsFields = ({name, handleBlur, disabled, handleChange}: AddressInputFieldsProps) => {
  const autocompleteRef = useRef<google.maps.places.Autocomplete | null>(null)
  const {setFieldValue, setFieldTouched} = useFormikContext()
  const handleLoad = (autocomplete: any) => {
    autocompleteRef.current = autocomplete
  }

  const handlePlaceChanged = async () => {
    if (autocompleteRef.current !== null) {
      const place = autocompleteRef.current.getPlace()
      const addressComponents = place.address_components
      if (!addressComponents) return

      const streetNumber = addressComponents.find((component: any) => component.types.includes('street_number'))
      const route = addressComponents.find((component: any) => component.types.includes('route'))
      const locality = addressComponents.find((component: any) => component.types.includes('locality'))
      const country = addressComponents.find((component: any) => component.types.includes('country'))
      const postalCode = addressComponents.find((component: any) => component.types.includes('postal_code'))
      const province = addressComponents.find((component: any) => component.types.includes('administrative_area_level_1'))
      const streetAddress = `${streetNumber?.long_name || ''} ${route?.long_name || ''}`.trim()
      setFieldValue(`${name}.address`, streetAddress)
      setFieldValue(`${name}.city`, locality?.long_name || '')
      setFieldValue(`${name}.province_or_state`, province?.long_name || '')
      setFieldValue(`${name}.country`, country?.long_name || '')
      setFieldValue(`${name}.zip_or_postal`, postalCode?.long_name || '')

      setFieldTouched(`${name}.address`, true)
      setFieldTouched(`${name}.city`, true)
      setFieldTouched(`${name}.province_or_state`, true)
      setFieldTouched(`${name}.country`, true)
      setFieldTouched(`${name}.zip_or_postal`, true)

      handleChange?.({
        target: {
          name: `${name}.address`,
          value: streetAddress
        }
      })

      // Hack to wait for new value to be applied
      // Pending https://github.com/jaredpalmer/formik/issues/529
      // executed after the JavaScript runtime has finished processing any tasks already queued in the event loop.
      setTimeout(() => {
        handleBlur && handleBlur()
      }, 0)
    }
  }

  return (
    <VStack w="full" gap={0}>
      <FieldInput
        disabled={disabled}
        componentType="address-input"
        placeholder={'Address'}
        handleLoad={handleLoad}
        handlePlaceChanged={handlePlaceChanged}
        handleChange={handleChange}
        handleBlur={handleBlur}
        name={`${name}.address`}
      />
      <FieldInput placeholder={'Apt,Suite,etc..'} componentType="input" name={`${name}.address2`} handleChange={handleChange} handleBlur={handleBlur} disabled={disabled} />
      <FieldInput placeholder="City" componentType="input" name={`${name}.city`} handleChange={handleChange} handleBlur={handleBlur} disabled={disabled} />
      <Grid w="full" gridTemplateColumns="1fr 1fr" gap={2}>
        <FieldInput placeholder="Province / State" componentType="input" name={`${name}.province_or_state`} handleChange={handleChange} handleBlur={handleBlur} disabled={disabled} />
        <FieldInput placeholder="Zip or Postal Code" componentType="input" name={`${name}.zip_or_postal`} handleChange={handleChange} handleBlur={handleBlur} disabled={disabled} />
      </Grid>
      <FieldInput placeholder="Country" componentType="input" name={`${name}.country`} handleChange={handleChange} handleBlur={handleBlur} disabled={disabled} />
    </VStack>
  )
}
